import defaultClient from '@/plugins/axios/defaultClient'

export default {
  getCredentials() {
    return defaultClient.get(`/credentials/`)
  },
  postCredentials(credentials) {
    return defaultClient.post(`/credentials/`, credentials)
  },
  patchCredentials(credential) {
    return defaultClient.patch(`/credentials/${credential.uuid}/`, credential)
  },
}
